exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".article-edit-modal textarea{box-shadow:none;margin-bottom:0}.article-edit-modal mw-modal-footer md-checkbox a{color:#28bbbb;text-decoration:underline}#mw .mw-mini-modal .md-toolbar-tools mw-modal-header-title{padding-right:0}.article-edit-input-container{margin:18px 10px 0 0}.article-edit-dialog-auto-height{height:auto;min-height:0;-ms-flex:0 1 auto;flex:0 1 auto}#mw .article-edit-modal__html-tooltip{margin:0 0 0 6px}.article-edit-modal__tnc-text{position:relative;top:2px}.article-edit-input-container-margin{margin-top:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/articles/article-edit-modal/article-edit-modal.component.css
 ** module id = 70
 ** module chunks = 0 1
 **/